import type { Reaction } from "./reacting.ts";

export const CHIPS_INLINE = 6;

export const KINDS_BEFORE_A_SHEET = 12;

const whenPressed = (one: Reaction): number => {
  const at = Date.parse(one.at);
  return Number.isNaN(at) ? 0 : at;
};

export function inOrder(reactions: readonly Reaction[]): Reaction[] {
  return [...reactions].sort(
    (one, two) =>
      two.count - one.count || whenPressed(one) - whenPressed(two) || one.emoji.localeCompare(two.emoji),
  );
}

export function holdingOrder(held: readonly string[], reactions: readonly Reaction[]): Reaction[] {
  const byEmoji = new Map(reactions.map((one) => [one.emoji, one]));
  const kept = held.map((emoji) => byEmoji.get(emoji)).filter((one): one is Reaction => one !== undefined);
  const seen = new Set(kept.map((one) => one.emoji));
  return [...kept, ...inOrder(reactions.filter((one) => !seen.has(one.emoji)))];
}

export type WhatMoreDoes = "row" | "sheet";

export type RowPlan = {
  shown: Reaction[];
  more: number;
  opens: WhatMoreDoes | null;
};

export function planRow(ordered: readonly Reaction[], expanded = false): RowPlan {
  if (ordered.length <= CHIPS_INLINE) return { shown: [...ordered], more: 0, opens: null };
  if (ordered.length <= KINDS_BEFORE_A_SHEET && expanded)
    return { shown: [...ordered], more: 0, opens: null };
  return {
    shown: ordered.slice(0, CHIPS_INLINE),
    more: ordered.length - CHIPS_INLINE,
    opens: ordered.length > KINDS_BEFORE_A_SHEET ? "sheet" : "row",
  };
}
